import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import ShoppingForm from '../components/notifications/ShoppingForm'
import useNotificationsApi from '../hooks/notifications/useNotificationsApi'

export default function CreateShoppingPage() {
  const history = useHistory()
  const location = useLocation()
  const [_, { createNotification }] = useNotificationsApi()

  const { shopping } = location.state || {}

  return (
    <ShoppingForm
      onSubmit={(values) => createNotification(values)}
      handleCancel={() =>
        history.push(shopping ? '/compras' : '/notificaciones')
      }
      shopping={shopping}
    />
  )
}
